import { Component } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { DATA_UPDATE, VIDEO_ATENCION } from "@constants/url.constant";

@Component({
    selector: "app-video-atencion",
    templateUrl: "video-atencion.component.html",
    styleUrls: ["video-atencion.component.scss"],
    standalone: false
})
export class VideoatencionComponent {
  constructor(private readonly location: Location, readonly router: Router) {}

  goToVideoAtencion() {
    this.router.navigate([DATA_UPDATE, VIDEO_ATENCION]);
  }

  goBack() {
    this.location.back();
  }
}
